import React from "react";
import FormCard from "./FormCard";
import NoResults from "./NoResults";

const FormsGrid = ({ forms, currentForms }) => {
  if (currentForms.length === 0) {
    return <NoResults />;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {currentForms.map((form, index) => (
        <FormCard key={form.id} form={form} index={index} />
      ))}
    </div>
  );
};

export default FormsGrid;